<template>
    <div
        class="list-group-item"
        style="cursor: move; padding: 20px"
        :class="{ 'inactive-item': dispatcher.is_inactive }"
    >
        <div class="row">
            <div class="col-sm-1">
                <img :src="dispatcher.logo_url" v-if="dispatcher.logo_url" style="max-width: 100px">
            </div>
            <div class="col-sm-3">
                <b>{{ dispatcher.name }}</b><br>
                {{ dispatcher.phone }}<br>
                {{ dispatcher.email }}
            </div>
            <div class="col-sm-3">
                <ul>
                    <li v-for="info in dispatcher.info_short">{{ info.text }}</li>
                </ul>
            </div>
            <div class="col-sm-3">
                <ul>
                    <li v-for="info in dispatcher.info_long">{{ info.text }}</li>
                </ul>
            </div>
            <div class="col-sm-1">
                <span v-if="dispatcher.is_primary">Highlighted<br></span>
                <span v-if="dispatcher.is_click_to_call">Click-to-call<br></span>
                <span v-if="dispatcher.is_inactive">Inactive</span>
                <span v-else>Active</span>
            </div>
            <div class="col-sm-1">
                <el-button @click="show_dialogs.update_dialog = true" type="primary">Edit</el-button>
            </div>
        </div>

        <dispatcher-dialog-update
            :dispatcher="dispatcher"
            :show="show_dialogs.update_dialog"
            @close="show_dialogs.update_dialog = false"
            @updated="$emit('updated')"
        >
        </dispatcher-dialog-update>
    </div>

</template>
<script>
import DispatcherDialogUpdate from "./dispatcher-dialog-update";

export default {
        components: {
            DispatcherDialogUpdate
        },
        props: [
            'dispatcher'
        ],
        data() {
            return {
                show_dialogs: {
                    update_dialog: false
                }
            }
        },
        methods: {
        }
    }
</script>
